module.exports = __webpack_public_path__ + "img/markerFerryRed.63850c8e.svg";